module.exports = new __parcel__URL__("mid_ground_cloud_2-min.fd8940e5.png").toString();